import { useState, useEffect } from "react";
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/react/24/outline";
import cdpService from "../../../apiService/cdp.service";

export default function ProductSelect({ selectedDomain, setSelectedDomain }) {
  const [domainList, setDomainList] = useState([]);

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const response = await cdpService.getAllProducts();
        const result = response.data;
        
        if (result.success && result.data && Array.isArray(result.data.products)) {
          setDomainList(result.data.products);
        } else {
          console.error("Unexpected API response format:", result);
        }
      } catch (error) {
        console.error("Error fetching domains:", error);
      }
    };
  
    fetchDomains();
  }, []);

  return (
    <Listbox value={selectedDomain} onChange={setSelectedDomain}>
      <div className="relative">
        <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-2.5 pl-4 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600 sm:text-sm">
          <span className="block truncate text-gray-600">
            {selectedDomain?.product_name || "Select a domain"}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon aria-hidden="true" className="size-5 text-gray-400" />
          </span>
        </ListboxButton>

        <ListboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
          {domainList.length > 0 ? (
            domainList.map((domain) => (
              <ListboxOption
                key={domain.id}
                value={domain}
                className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white"
              >
                <span className="block truncate font-normal group-data-[selected]:font-semibold">
                  {domain.product_name}
                </span>

                <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                  <CheckIcon aria-hidden="true" className="size-5" />
                </span>
              </ListboxOption>
            ))
          ) : (
            <div className="py-2 px-3 text-gray-500">No domains available</div>
          )}
        </ListboxOptions>
      </div>
    </Listbox>
  );
}
